import * as React from "react";
import {
  Column,
  Columns,
  Divider,
  Stack,
  Text,
} from "@origin-digital/ods-core";
import { useFormikContext } from "formik";
import { FormValues } from "./types";
import ReadOnlyFieldWrapper from "./ReadOnlyFieldWrapper";
import { capitalizeFirstChar } from "./helper";
import FormContext from "src/context/FormContext";

const ReadOnlyPropertyAccessInPremise = () => {
  const { values } = useFormikContext<FormValues>();
  const { formState } = React.useContext(FormContext);
  return (
    <Stack
      space={{
        xs: "large",
        md: "xlarge",
      }}
    >
      <Stack
        space={{
          xs: "xlarge",
          md: "xlarge",
        }}
      >
        {/* Property access */}
        <ReadOnlyFieldWrapper value={values.propertyAccess}>
          <Columns
            collapseBelow="md"
            space={{
              xs: "none",
              md: "xlarge",
            }}
            alignY="stretch"
          >
            {/* Fields */}
            <Column>
              <Stack space="xsmall">
                <Stack space="xxsmall">
                  <Text variant="body-small" tone="neutralLight">
                    Is there clear and safe access to the property?
                  </Text>
                  <Text>
                    {formState?.electricityService?.channel === "CLAIM"
                      ? "Yes"
                      : capitalizeFirstChar(values.propertyAccess)}
                  </Text>
                </Stack>
                <Divider />
              </Stack>
            </Column>
          </Columns>
        </ReadOnlyFieldWrapper>
        {values.propertyAccess !== "yes" && (
          <ReadOnlyFieldWrapper value={values.preventingAccess}>
            <Columns
              collapseBelow="md"
              space={{
                xs: "none",
                md: "xlarge",
              }}
              alignY="stretch"
            >
              {/* Fields */}
              <Column>
                <Stack space="xsmall">
                  <Stack space="xxsmall">
                    <Text variant="body-small" tone="neutralLight">
                      What is preventing access?
                    </Text>
                    {<Text>{values.preventingAccess}</Text>}
                  </Stack>
                  <Divider />
                </Stack>
              </Column>
              {/* Fields */}
            </Columns>
          </ReadOnlyFieldWrapper>
        )}
        {/* End Property access */}
      </Stack>
    </Stack>
  );
};

export default ReadOnlyPropertyAccessInPremise;
